<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="closing_date"
    >
      <span>{{ trans('addresses.details.form.field.closing_date.label') }}</span>
    </label>
    <div
      class="form-field__input field-input field-input--small field-input--date"
      :class="{ disabled: unlimited }"
    >
      <vue-date-picker
        v-model="closingDate"
        name="closing_date"
        format="dd/MM/yyyy"
        locale="fr"
        :class="{ disabled: unlimited, error: error }"
        :enable-time-picker="false"
        :min-date="from"
        auto-apply
      />
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
    <div class="input-checkbox form-field__option">
      <input
        id="closing_date_unlimited"
        v-model="unlimited"
        type="checkbox"
        :value="1"
      >
      <label for="closing_date_unlimited">
        <span>{{ trans('addresses.details.form.field.closing_date.unlimited') }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import moment from '@tools/moment';
import translation from '@elements/translation';

export default {
  components: { VueDatePicker },
  mixins: [ translation, moment ],
  props: {
    modelValue: { type: String, required: false, default: null },
    error: { type: String, required: false, default: null },
    validationRules: { type: Object, required: true },
    from: { type: String, required: false, default: null },
  },
  computed: {
    unlimited: {
      get() {
        return this.modelValue === null;
      },
      set(unlimited) {
        if (unlimited) {
          this.emitValue(null);
          return;
        }
        this.emitValue(this.from ? this.getSimpleDate(this.from) : this.getSimpleDate(new Date()));
      },
    },
    closingDate: {
      get() {
        return this.modelValue;
      },
      set(modelValue) {
        this.emitValue(this.getSimpleDate(modelValue));
      },
    },
  },
  watch: {
    from(from) {
      if (this.isBefore(this.closingDate, from)) {
        this.closingDate = from;
      }
    },
  },
  methods: {
    emitValue(modelValue) {
      this.$emit('update:modelValue', modelValue);
      this.$emit('focusout');
    },
  },
};
</script>
